<template>
  <admin-base
    add-btn-text="Add New Level"
    :add-btn-permission="addRolePermission"
    @create="showModalForm"
    @search="(val) => (search = val)"
  >
    <admin-role-levels-table
      ref="table"
      :search="search"
      @edit="showModalForm"
      @delete="showdeleteDialog"
    />
    <admin-role-levels-modal-form ref="modalForm" @success="refreshTable" />
    <anchor-confirm-dialog
      :title="`Are you sure you want to delete '${levelName}' level?`"
      max-width="600"
      @confirm="deleteLevel"
      @cancel="clearLevel"
      ref="deleteLevelDialog"
    />
  </admin-base>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import AdminBase from '@/components/admin/Base';
import AdminRoleLevelsTable from '@/components/admin/controls/levels/RoleLevelsTable';
import AdminRoleLevelsModalForm from '@/components/admin/controls/levels/form/RoleLevelsModalForm';

export default {
  name: 'AdminControlsRolesView',
  components: {
    AdminBase,
    AdminRoleLevelsTable,
    AdminRoleLevelsModalForm,
  },
  data: () => ({
    search: null,
    levelToDelete: undefined,
  }),
  computed: {
    addRolePermission: vm => vm.$permissions.ADD_ROLE_LEVELS,
    levelName: vm => vm.levelToDelete?.name,
  },
  methods: {
    showModalForm(roleLevel) {
      this.$refs.modalForm.open(this.$utils.deepCopy(roleLevel));
    },
    showdeleteDialog(roleLevel) {
      this.$refs.deleteLevelDialog.open();
      this.levelToDelete = roleLevel;
    },
    refreshTable() {
      this.$refs.table.fetch();
    },
    clearLevel() {
      this.levelToDelete = undefined;
    },
    deleteLevel() {
      this.$requests
        .delete(`/v1/role_levels/${this.levelToDelete._id}`)
        .then(() => {
          this.$toast.success(`Deleted role level ${this.levelToDelete.name}`, { timeout: 3000 });
          this.levelToDelete = undefined;
          this.refreshTable();
        })
        .catch(err => {
          this.$toast.error(err.response.data.message || `Could not delete ${this.levelToDelete.name}...`, {
            timeout: 3000,
          });
        });
    },
  },
};
</script>
